// extracted by mini-css-extract-plugin
export default {"container":"VideosAnalytics_container__qtP4M","datepicker_Box":"VideosAnalytics_datepicker_Box__tT3qC"};